import React from "react";
import image from "../images/Line.svg";
import { BsGithub } from "react-icons/bs";
import Github from "../images/Github.svg";
import mail from "../images/Email.svg";
import linkdln from "../images/Linkedin.svg";
import twitter from "../images/Twitter.svg";
import { Link } from "react-router-dom";

const SidebarMobile = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          marginTop: "2%",
          //   width: "100%",
        }}
      >
        <img src={image} alt="" />
        <div style={{ marginTop: "1rem" }}>
          <Link to="https://github.com/the-first-elder">
            <img src={Github} alt="" />{" "}
          </Link>
        </div>
        <div style={{ marginTop: "1rem" }}>
          <Link to="https://www.linkedin.com/in/mayowa-abikoye">
            <img src={linkdln} alt="" />
          </Link>
        </div>
        <div style={{ marginTop: "1rem" }}>
          <Link to="mailto: emmanuelmayowa95@gmail.com">
            <img src={mail} alt="" />{" "}
          </Link>
        </div>
        <div style={{ marginTop: "1rem" }}>
          <Link to="https://twitter.com/The_First_Elder">
            <img src={twitter} alt="" />
          </Link>
        </div>
      </div>
    </>
  );
};

export default SidebarMobile;
